import { Grid, Box, useMediaQuery } from '@mui/material';
import React from 'react';
import Section from '../../../shared/Section/Section';
import Statistic from '../../../shared/Statistic/Statistic';
import PersonCard from '../../../shared/Cards/PersonCard';
import SwiperComponent from '../../../shared/SwiperComponent/SwiperComponent';
import VideoReviewCard from '../../../shared/Cards/VideoReviewCard';

const studentsPath = 'students';
const logosPath = 'studentsWork';

function Graduates({
  title,
  subtitle,
  data: { statistic = [], people = [] },
  studentsData,
  studentsWorkData,
  noBg = false,
  titleSx,
}) {
  const isMd = useMediaQuery((theme) => theme.breakpoints.down('md'));
  return (
    <Section
      subtitle={subtitle}
      title={title}
      bg={noBg ? null : 'graduates'}
      titleSx={titleSx}
      withoutBg={noBg}
    >
      <Grid container>
        <Grid item xs={12} xl={9}>
          <Box
            sx={{
              ...(titleSx && !isMd
                ? { position: 'absolute', right: 8, top: 0 }
                : {}),
              flexGrow: 1,
              paddingBottom: {
                xs: '40px',
                xl: '48px',
              },
            }}
          >
            <Statistic statistic={statistic} />
          </Box>
        </Grid>
      </Grid>

      <Box>
        <SwiperComponent
          slidesPerView={1.2}
          spaceBetween={16}
          breakpoints={{
            400: {
              slidesPerView: 1.4,
              spaceBetween: 4,
            },
            535: {
              slidesPerView: 1.5,
              spaceBetween: 8,
            },
            700: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            1010: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
            1410: {
              slidesPerView: 4,
              spaceBetween: 24,
            },
          }}
          centeredSlides={false}
          slides={people.map(
            (person) =>
              function () {
                return (
                  <Box
                    sx={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                    key={person.fullName}
                  >
                    <>
                      {person.video ? (
                        <VideoReviewCard
                          {...person}
                          height="100%"
                          image={studentsData[`previews/${person.video}`]}
                        />
                      ) : (
                        <PersonCard
                          {...person}
                          height="100%"
                          image={
                            studentsData[`${studentsPath}/${person.photo}`]
                          }
                          logo={
                            studentsWorkData[
                              `${logosPath}/${person.company?.logo}`
                            ]
                          }
                        />
                      )}
                    </>
                  </Box>
                );
              },
          )}
        />
      </Box>
    </Section>
  );
}

export default Graduates;
